// Which label design this device prints with (a convenience, not shared state).
// Anything stored that is not a registered template falls back to the default.

import {
  DEFAULT_LABEL_TEMPLATE_ID,
  isLabelTemplateId,
} from "../../../components/Print/engine/labelTemplates";

const TEMPLATE_CHOICE_KEY = "bw-print-label-template-v1";

const getStorage = () => {
  try {
    return typeof window !== "undefined" ? window.localStorage : null;
  } catch (_error) {
    return null;
  }
};

export const readTemplateChoice = (storage = getStorage()) => {
  try {
    const value = storage?.getItem?.(TEMPLATE_CHOICE_KEY);
    return isLabelTemplateId(value) ? value : DEFAULT_LABEL_TEMPLATE_ID;
  } catch (_error) {
    return DEFAULT_LABEL_TEMPLATE_ID;
  }
};

export const saveTemplateChoice = (templateId, storage = getStorage()) => {
  if (!isLabelTemplateId(templateId)) return;
  try {
    storage?.setItem(TEMPLATE_CHOICE_KEY, templateId);
  } catch (_error) {}
};

/** Reprints start from the design the job was last printed with, when recorded. */
export const templateFromJob = (job) => {
  const attempts = Array.isArray(job?.attempts) ? job.attempts : [];
  const recorded = attempts[attempts.length - 1]?.layout?.templateId;
  return isLabelTemplateId(recorded) ? recorded : null;
};
